/* Cover My Plate · live plates. Used by the landing tiles (sections/cx-landing.liquid, tile setting "Live plate") and by
   the plate on the Supra photo (landing hero and the home "Plate covers" door, data-cxp-morph on the photo wrapper).
   Every plate is drawn with the real product parts:
   social: laid out like the social cover builder (cmp-social-builder.js paintCover). Our own Instagram and TikTok type
           in with QR codes that open those pages, then "yourhandle", whose QR code opens the social cover builder.
   logo:   our CMP logo on the real cover finishes (Forged Carbon, Black, Carbon Twill, White), wiping from one to the next.
   vanity / mini / jdmv: the bolt-on versions (mounting holes; mini is a 12 x 3 strip with two top slots, measured from the blank; Japanese plates with holes).
   blackout / carbon: the plain plate finishes (Black and White; Carbon Fiber Twill and Forged Carbon), wiping between them.
   flogo / fsocial / fcarbon: plate frames (printed logo and words; @handle typing into the bottom bar; real carbon).
   jdm:    the Japanese plate builder's own backgrounds, borders and plate fonts (plate-customizer.css metrics, 350 x 175),
           wiping through a few looks.
   Supra:  the photo's plate is covered by a matching plate that starts as our social cover and morphs through the others.
   M4:     with "vanity@3000:" in front of the corners, the plate starts as forged carbon with our logo and morphs through vanity looks.
   Animations run only while on screen; with reduced motion everything shows one still frame. */
(function () {
  'use strict';
  var FILES = 'https://cdn.shopify.com/s/files/1/0534/4126/5863/files/';
  var JPF = 'https://plates.customjapaneseplates.com/fonts/';
  var LOGO = FILES + 'cmp-logo-white-tagline.png';
  var PLATE = FILES + 'image_650390dc-e5e8-46ab-a25b-241d15272e50.png?v=1791913849&width=1000';
  // our frame cutouts are theme assets next to this script
  var ASSETS = (function () { var c = document.currentScript; return c && c.src ? c.src.replace(/[^\/]*$/, '') : ''; })();
  var FR_IMG = { print: ASSETS + 'cmp-frame-print.webp', white: ASSETS + 'cmp-frame-white.webp', forged: ASSETS + 'cmp-frame-forged.webp', twill: ASSETS + 'cmp-frame-twill.webp' };
  var FORGED = 'https://cdn.shopify.com/s/files/1/0534/4126/5863/products/ForgedWebTemplate.jpg?width=900';

  var CSS = [
    '@font-face{font-family:"cxp_jp";src:url(' + JPF + 'japan_font-webfont.woff2) format("woff2");font-display:block}',
    '@font-face{font-family:"cxp_jp_top";src:url(' + JPF + 'japan_top-webfont.woff2) format("woff2");font-display:block}',
    '@font-face{font-family:"cxp_jp_bot";src:url(' + JPF + 'japan_bottom_alpha-webfont.woff2) format("woff2");font-display:block}',
    '.lp{position:absolute;inset:0;display:grid;place-items:center;overflow:hidden;container-type:inline-size;background:#0d0e10}',
    '.lp__bg{position:absolute;inset:-12px;background:center/cover no-repeat;filter:blur(7px) brightness(.38) saturate(1.2);transform:scale(1.06)}',
    /* the social photo is a night shot: lift it so the tile matches the others */
    '.lp--social .lp__bg{filter:blur(7px) brightness(.85) saturate(1.1)}',
    '.lp::after{content:"";position:absolute;inset:0;background:radial-gradient(60% 55% at 50% 50%,rgba(255,255,255,.09),transparent 70%);pointer-events:none}',
    '.lp__plate{position:relative;z-index:2;width:80%;aspect-ratio:2/1;border-radius:3.6%/7.2%;overflow:hidden;background:#050506;box-shadow:0 0 0 1px rgba(0,0,0,.8),0 1.5px 0 1px rgba(255,255,255,.14),0 22px 34px -12px rgba(0,0,0,.9);transform:perspective(900px) rotateX(4deg) rotateY(-6deg);transition:transform .6s cubic-bezier(.2,.8,.2,1)}',
    '.cxl__tile:hover .lp__plate{transform:perspective(900px) rotateX(0) rotateY(0) scale(1.03)}',
    '.lp__cv{display:block;width:100%;height:100%}',
    '.lp--mini .lp__plate{width:88%;aspect-ratio:4/1;border-radius:2.5%/10%}',
    '.lp--mini .cxp__lg img{width:40%;max-width:40%;margin-top:3%}',
    '.lp__chip{position:absolute;z-index:3;left:50%;bottom:7%;transform:translateX(-50%);padding:1.4cqw 3cqw;border-radius:999px;background:rgba(10,11,12,.72);backdrop-filter:blur(6px);color:#F2F1ED;font:600 3.1cqw/1 Inter,system-ui,sans-serif;letter-spacing:.02em;white-space:nowrap;transition:opacity .3s ease}',
    /* faces: stacked layers inside a plate box; the newest one wipes in over the last */
    '.cxp{position:absolute;inset:0;overflow:hidden;container-type:inline-size}',
    '.cxp__f{position:absolute;inset:0;overflow:hidden}',
    /* a slow crossfade: no wipes or flashes */
    '.cxp__f.is-in{animation:cxpFade 1.2s ease-in-out both}',
    '@keyframes cxpFade{from{opacity:0}to{opacity:1}}',
    '.cxp__glint{position:absolute;inset:0;z-index:5;pointer-events:none;background:linear-gradient(100deg,transparent 42%,rgba(255,255,255,.75) 49%,rgba(215,255,31,.55) 51%,transparent 58%);background-size:260% 100%;background-position:130% 0;opacity:0}',
    '.cxp__glint.is-on{animation:cxpGlint .9s cubic-bezier(.65,0,.25,1)}',
    '@keyframes cxpGlint{0%{opacity:1;background-position:130% 0}100%{opacity:1;background-position:-30% 0}}',
    '.cxp__f::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(160deg,rgba(255,255,255,.14),transparent 38%,rgba(0,0,0,.16))}',
    /* logo face */
    '.cxp__lg{background:center/cover no-repeat;display:flex;align-items:center;justify-content:center}',
    '.cxp__lg img{width:62%;max-width:62%;height:auto;flex:none;filter:drop-shadow(0 .5cqw 1.2cqw rgba(0,0,0,.45))}',
    '.cxp img{transform:none!important;transition:none!important}',
    '.cxp .cxp__lg img{height:auto!important;object-fit:contain!important}',
    /* mounting slots, measured from our blanks: about 1 x 0.25 in, centres 20% in from each side.
       full size (12 x 6): top and bottom pairs, 0.63 in from the edge. mini (12 x 3): one top pair, 0.6 in down */
    '.cxp__holes{position:absolute;inset:0;z-index:2;pointer-events:none}',
    '.cxp__holes b{position:absolute;width:8.4%;height:3.8%;border-radius:999px;background:#0b0b0c;box-shadow:inset 0 .25cqw .5cqw rgba(0,0,0,.9),0 .12cqw 0 rgba(255,255,255,.28)}',
    '.cxp__holes b:nth-child(1){left:15.8%;top:8.6%}.cxp__holes b:nth-child(2){right:15.8%;top:8.6%}.cxp__holes b:nth-child(3){left:15.8%;bottom:8.6%}.cxp__holes b:nth-child(4){right:15.8%;bottom:8.6%}',
    '.cxp__holes.is-mini b{height:8.4%}.cxp__holes.is-mini b:nth-child(1),.cxp__holes.is-mini b:nth-child(2){top:15.8%}',
    '.cxp__sheen{position:absolute;inset:0;background:linear-gradient(115deg,transparent 30%,rgba(255,255,255,.16) 44%,rgba(255,255,255,.04) 52%,transparent 64%);pointer-events:none}',
    '.cxp__lg.is-light img{filter:brightness(0) drop-shadow(0 .3cqw .8cqw rgba(255,255,255,.4))}',
    /* japanese plate face: the builder\'s 350 x 175 layout, scaled to fit */
    '.cxp__jp .jp{position:absolute;left:0;top:0;width:350px;height:175px;transform-origin:0 0;color:#000}',
    '.cxp__jp .jp img{position:absolute;inset:0;width:100%;height:100%;max-width:none}',
    '.cxp__jp .jp b{position:absolute;font-weight:400;text-transform:uppercase;white-space:nowrap;z-index:1}',
    '.cxp__jp .jp__pref{top:10px;left:70px;font:65px/60px cxp_jp,sans-serif}',
    '.cxp__jp .jp__top{top:12px;right:60px;font:55px/55px cxp_jp_top,sans-serif}',
    '.cxp__jp .jp__top.is-solo{right:auto;left:50%;transform:translateX(-50%)}',
    '.cxp__jp .jp__hira{bottom:15px;left:40px;font:50px/57px cxp_jp,sans-serif}',
    '.cxp__jp .jp__num{left:0;top:0;width:350px;box-sizing:border-box;padding-left:70px;text-align:center;font:112px/1.4 cxp_jp_bot,sans-serif;letter-spacing:-5px}',
    '.cxp__jp .jp__num.is-wide{padding-left:0}',
    '.cxp__jp .jp__num span{position:relative;top:45px;white-space:pre}',
    /* plate frames */
    /* plate frames: cutouts of our real frames (photos), the CVRMYPLT plate showing through the window and the mounting holes */
    '.lp--flogo .lp__plate,.lp--fsocial .lp__plate,.lp--fcarbon .lp__plate{width:84%;aspect-ratio:1.97/1;border-radius:0;background:transparent;box-shadow:none;overflow:visible}',
    '.lp--fsocial .lp__bg{filter:blur(7px) brightness(.85) saturate(1.1)}',
    '.lp--flogo .lp__chip,.lp--fsocial .lp__chip,.lp--fcarbon .lp__chip{bottom:auto;top:5%}',
    '.lp--flogo .cxp,.lp--fsocial .cxp,.lp--fcarbon .cxp,.cxp__fr{overflow:visible}.cxp__fr::after{display:none}',
    /* the plate behind the frame; white frames get it in reverse (white plate, black letters) */
    '.fr__pl{position:absolute;left:3%;right:3%;top:3.5%;bottom:9%;border-radius:2%/4%;background:url(' + PLATE + ') center/100% 100% no-repeat}',
    '.is-white .fr__pl{filter:invert(1) contrast(.95)}',
    '.cxp .fr__img{position:absolute!important;inset:0;width:100%!important;height:100%!important;object-fit:fill!important;display:block;filter:drop-shadow(0 .35cqw .45cqw rgba(0,0,0,.6)) drop-shadow(0 2.2cqw 2.6cqw rgba(0,0,0,.55))}',
    '.fr__top,.fr__bot{position:absolute;display:flex;align-items:center;justify-content:center;gap:2.2cqw;color:#F2F1ED;white-space:nowrap;z-index:2}',
    /* print area on our flat frames: top bar between the holes, and the bottom bar */
    '.fr__top{top:2.2%;left:29%;right:29%;height:15%}',
    '.fr__bot{top:80.6%;bottom:1.8%;left:12%;right:12%;font:800 italic 5.4cqw/1 "Barlow Condensed","CX Barlow Condensed",Arial,sans-serif;text-transform:uppercase;letter-spacing:.04em;font-synthesis:none;text-shadow:0 .2cqw .2cqw rgba(0,0,0,.6)}',
    /* carbon frames have a thin top bar: the print goes on the bottom bar */
    '.is-carbon .fr__top{top:86.4%;bottom:1.6%;height:auto}.is-carbon .fr__bot{top:86.4%;bottom:1.6%}',
    '.cxp .fr__top img{height:62%!important;width:auto!important;max-width:100%;object-fit:contain!important;filter:drop-shadow(0 .2cqw .2cqw rgba(0,0,0,.6))}',
    '.is-white .fr__top img{filter:brightness(0)}.is-white .fr__bot{color:#111;text-shadow:0 .15cqw 0 rgba(255,255,255,.8)}',
    '.fr__bot.is-soc{font:400 6cqw/1 "LP Hand","Arial Black",Arial,sans-serif;text-transform:none;letter-spacing:0}',
    '.cxp .fr__bot.is-soc img{height:7cqw!important;width:7cqw!important;flex:none}',
    '.fr__caret{display:inline-block;width:.6cqw;height:5cqw;margin-left:.6cqw;background:#D7FF1F;vertical-align:middle}',
    /* the plate on the Supra photo */
    '.cxp-layer{position:absolute;inset:0;pointer-events:none;transition:transform .7s cubic-bezier(.2,.8,.2,1)}',
    '.cxd__door:hover .cxp-layer{transform:scale(1.035)}',
    '.cxp-hero{position:absolute;border-radius:5%/10%;overflow:hidden;box-shadow:0 0 0 .5px rgba(0,0,0,.55),0 1px 2px rgba(0,0,0,.6)}',
    '.cxp-hero .cxp__f{filter:brightness(.86) contrast(.96)}',
    '.cxp-hero::after{content:"";position:absolute;inset:0;z-index:6;background:linear-gradient(180deg,rgba(255,255,255,.07),rgba(0,0,0,.18));pointer-events:none}',
    '@media (prefers-reduced-motion:reduce){.lp__plate,.cxp-layer{transition:none}.cxp__f.is-in,.cxp__glint.is-on{animation:none}}'
  ].join('');

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function preload(src) { return new Promise(function (r) { var i = new Image(); i.onload = i.onerror = function () { r(i); }; i.src = src; }); }

  // run a loop only while the element is on screen
  function watch(node, loop) {
    var on = false, running = false;
    var go = function () { if (running || !on) return; running = true; loop(function () { return on && !document.hidden; }).then(function () { running = false; if (on) setTimeout(go, 400); }); };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { on = es[0].isIntersecting; go(); }, { threshold: .25 }).observe(node);
    else { on = true; go(); }
    document.addEventListener('visibilitychange', go);
  }

  /* ------------------------------------------------------------------ faces */
  // a stack of faces in a plate box; show(face) wipes the new one in over the old one
  function Stage(box) {
    this.box = box; this.cur = null;
    this.glint = el('span', 'cxp__glint'); box.appendChild(this.glint);
  }
  Stage.prototype.show = function (face, animate) {
    var f = face.node;
    f.classList.remove('is-in');
    this.box.insertBefore(f, this.glint);
    if (face.fit) face.fit();
    if (animate && !reduce) { void f.offsetWidth; f.classList.add('is-in'); }
    var old = this.cur; this.cur = f;
    if (old && old !== f) setTimeout(function () { if (old.parentNode && old !== f) old.remove(); }, animate && !reduce ? 1250 : 0);
  };

  // logo face: our logo on one finish
  var FINISHES = [
    { name: 'Forged Carbon', bg: FORGED },
    { name: 'Black', bg: FILES + 'Jap_Plate_Black.png' },
    { name: 'Carbon Twill', bg: FILES + 'Jap_Plate_Carbon_Twill.png' },
    { name: 'White', bg: FILES + 'Jap_Plate_White.png', light: true }
  ];
  // ForgedWebTemplate has a white border round the texture: crop it off like the drawn plates do
  function finish(f, bg) { f.style.backgroundImage = 'url("' + bg + '")'; if (bg === FORGED) { f.style.backgroundSize = '119% 136%'; f.style.backgroundPosition = '43% 43%'; } }
  function logoFace(fin, holes) {
    var f = el('div', 'cxp__f cxp__lg' + (fin.light ? ' is-light' : ''));
    finish(f, fin.bg);
    var im = el('img'); im.src = LOGO; im.alt = ''; f.appendChild(im);
    if (holes) f.appendChild(el('i', 'cxp__holes' + (holes === 'mini' ? ' is-mini' : ''), holes === 'mini' ? '<b></b><b></b>' : '<b></b><b></b><b></b><b></b>'));
    return { node: f, name: fin.name };
  }

  // japanese plate face, same parts as the builder
  var JP_LOOKS = [
    { bg: 'Jap_Plate_White.png', bd: 'Black_Border.png', ink: '#000', pref: '足立', top: '123', hira: 'ふ', num: '12345', name: 'White · Black' },
    { bg: 'Jap_Plate_Rising_Sun.png', bd: 'Black_Border.png', ink: '#000', pref: '群馬', top: '86', hira: 'た', num: 'TOUGE', name: 'Rising Sun' },
    { bg: 'Jap_Plate_Forged_Carbon.png', bd: 'White_Border_5.png', ink: '#fff', pref: '横浜', top: 'R34', hira: '', num: 'GOJIRA', name: 'Forged Carbon · White' },
    { bg: 'Jap_Plate_Crashing_Wave.png', bd: 'White_Border_5.png', ink: '#fff', pref: '品川', top: '330', hira: 'さ', num: '12-34', name: 'Crashing Wave · White' },
    { bg: 'Jap_Plate_Yellow.png', bd: 'Black_Border.png', ink: '#000', pref: '練馬', top: '500', hira: 'な', num: '88-08', name: 'Yellow · Black' }
  ];
  var JP_HOLES = {
    'Jap_Plate_White.png': 'Jap_Plate_White_w_holes.png',
    'Jap_Plate_Forged_Carbon.png': 'Jap_Plate_Forged_Carbon_w_holes_424d7d20-42c8-4118-bfee-ba96271f7817.png'
  };
  function holed(look) { var o = {}; for (var k in look) o[k] = look[k]; o.bg = JP_HOLES[look.bg] || look.bg; return o; }
  function jpFace(look) {
    var f = el('div', 'cxp__f cxp__jp');
    var p = el('div', 'jp');
    p.style.color = look.ink;
    p.innerHTML = '<img src="' + FILES + look.bg + '" alt=""><img src="' + FILES + look.bd + '" alt="">' +
      (look.pref ? '<b class="jp__pref">' + look.pref + '</b>' : '') +
      '<b class="jp__top' + (look.pref ? '' : ' is-solo') + '">' + look.top + '</b>' +
      (look.hira ? '<b class="jp__hira">' + look.hira + '</b>' : '') +
      '<b class="jp__num' + (look.hira ? '' : ' is-wide') + '"><span>' + look.num + '</span></b>';
    f.appendChild(p);
    var fit = function () {
      var w = f.clientWidth || (f.parentNode && f.parentNode.clientWidth) || 350;
      p.style.transform = 'scale(' + (w / 350) + ')';
      // long text shrinks to fit, like the builder
      var n = p.querySelector('.jp__num'), s = n.firstChild, room = (look.hira ? 280 : 350) - 12;
      n.style.fontSize = '';
      var sw = s.getBoundingClientRect().width / (w / 350);
      if (sw > room) n.style.fontSize = Math.floor(112 * room / sw) + 'px';
    };
    return { node: f, fit: fit, name: look.name };
  }

  /* ------------------------------------------------------------------ social cover painter */
  // laid out like the builder's QR cover: 960 x 480, icon over the handle on the left, QR on the right, Road Rage, gloss black
  var W = 960, H = 480, PAD = 60, QS = 320, QX = W - PAD - QS, TW = QX - PAD - 44, ISZ = 120;
  var HAND = "'LP Hand', 'Arial Black', Arial, sans-serif";
  function rr(x, X, Y, w, h, r) { x.beginPath(); x.moveTo(X + r, Y); x.arcTo(X + w, Y, X + w, Y + h, r); x.arcTo(X + w, Y + h, X, Y + h, r); x.arcTo(X, Y + h, X, Y, r); x.arcTo(X, Y, X + w, Y, r); x.closePath(); }
  function qrCells(text) {
    var q = window.qrcode(0, 'M'); q.addData(text); q.make();
    var n = q.getModuleCount(), cells = [];
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) if (q.isDark(r, c)) cells.push([c, r]);
    return { n: n, cells: cells };
  }
  function handleFrom(link, fallback) {
    var m = String(link || '').replace(/[?#].*$/, '').replace(/\/+$/, '').split('/').pop() || '';
    return m.replace(/^@/, '') || fallback;
  }
  function socialList(src) {
    var ig = src.getAttribute('data-ig'), tt = src.getAttribute('data-tt'), list = [];
    if (ig) list.push({ p: 'ig', h: handleFrom(ig, 'cover_my_plate'), url: ig });
    if (tt) list.push({ p: 'tt', h: handleFrom(tt, 'cover_my_plate'), url: tt });
    list.push({ p: 'ig', h: 'yourhandle', url: src.getAttribute('data-qr') || location.origin });
    return list;
  }
  var ICONS = {};
  function icons(src) {
    ['ig', 'tt'].forEach(function (k) { var u = src.getAttribute('data-ic-' + k); if (u && !ICONS[k]) { var im = new Image(); im.src = u; ICONS[k] = im; } });
    return Promise.all(Object.keys(ICONS).map(function (k) { var im = ICONS[k]; return im.complete ? 1 : new Promise(function (r) { im.addEventListener('load', r, { once: true }); im.addEventListener('error', r, { once: true }); }); }));
  }
  function fitFs(x, txt) { x.font = '92px ' + HAND; var w = x.measureText(txt).width; return w > TW * .95 ? Math.max(14, Math.floor(92 * TW * .95 / w)) : 92; }
  // one frame: plate, icon, the first `chars` letters of the handle, `shown` QR modules
  function paintSocial(x, it, chars, qr, shown, caret) {
    x.clearRect(0, 0, W, H);
    x.save(); rr(x, 0, 0, W, H, 34); x.clip();
    var g = x.createLinearGradient(0, 0, W * .4, H); g.addColorStop(0, '#1d1e22'); g.addColorStop(.55, '#060607'); g.addColorStop(1, '#0d0d0f');
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    var fs = fitFs(x, it.h), gh = ISZ + 24 + fs, top = (H - gh) / 2;
    var im = ICONS[it.p];
    if (im && im.complete && im.naturalWidth) x.drawImage(im, PAD, top, ISZ, ISZ);
    var txt = it.h.slice(0, chars), base = top + ISZ + 24 + fs / 2 + fs * .36;
    x.font = fs + 'px ' + HAND; x.fillStyle = '#fff'; x.textBaseline = 'alphabetic'; x.fillText(txt, PAD, base);
    if (caret) { x.fillStyle = '#D7FF1F'; x.fillRect(PAD + x.measureText(txt).width + 8, base - fs * .78, 7, fs * .86); }
    if (qr) {
      var m = QS / (qr.n + 8), off = 4 * m, y0 = (H - QS) / 2;
      x.fillStyle = '#fff';
      for (var i = 0; i < shown; i++) { var c = qr.cells[i]; x.fillRect(Math.floor(QX + off + c[0] * m), Math.floor(y0 + off + c[1] * m), Math.ceil(m + .5), Math.ceil(m + .5)); }
    }
    var sh = x.createLinearGradient(0, 0, W, H * .9);
    sh.addColorStop(0, 'rgba(255,255,255,.14)'); sh.addColorStop(.3, 'rgba(255,255,255,0)'); sh.addColorStop(.66, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(255,255,255,.06)');
    x.fillStyle = sh; x.fillRect(0, 0, W, H);
    x.restore();
  }
  function socialFace(it) {
    var f = el('div', 'cxp__f'), cv = el('canvas', 'lp__cv'); cv.width = W; cv.height = H; f.appendChild(cv);
    var q = qrCells(it.url); paintSocial(cv.getContext('2d'), it, it.h.length, q, q.cells.length, false);
    return { node: f, name: 'Social + QR' };
  }
  var handFont = null;
  function loadHand(url) {
    if (!handFont && url && window.FontFace) handFont = new FontFace('LP Hand', 'url(' + url + ')').load().then(function (f) { document.fonts.add(f); }).catch(function () {});
    return handFont || Promise.resolve();
  }
  function whenQR() { return new Promise(function (r) { (function t() { if (window.qrcode) r(); else setTimeout(t, 200); })(); }); }

  /* ------------------------------------------------------------------ tiles */
  function social(lp) {
    var cv = lp.querySelector('.lp__cv'); if (!cv) return;
    cv.width = W; cv.height = H;
    var x = cv.getContext('2d'), list = socialList(lp);
    Promise.all([loadHand(lp.getAttribute('data-hand')), icons(lp), whenQR(), document.fonts ? document.fonts.ready : 1]).then(function () {
      var qrs = list.map(function (it) { return qrCells(it.url); });
      if (reduce) { var k = list.length - 1; paintSocial(x, list[k], list[k].h.length, qrs[k], qrs[k].cells.length, false); return; }
      var shuffle = function (q) { return q.cells.slice().sort(function (a, b) { return (a[0] + a[1] * .35 + Math.random() * 3) - (b[0] + b[1] * .35 + Math.random() * 3); }); };
      paintSocial(x, list[0], 0, null, 0, true);
      var n = 0;
      watch(lp, function (on) {
        return (async function () {
          while (on()) {
            var k = n++ % list.length, it = list[k], q = { n: qrs[k].n, cells: shuffle(qrs[k]) };
            for (var i = 1; i <= it.h.length && on(); i++) { paintSocial(x, it, i, null, 0, true); await sleep(70 + Math.random() * 45); }
            // the QR code fills in once the handle is typed
            for (var s = 0; s <= 14 && on(); s++) { paintSocial(x, it, it.h.length, q, Math.round(q.cells.length * s / 14), true); await sleep(40); }
            for (var t = 0; t < 6 && on(); t++) { paintSocial(x, it, it.h.length, q, q.cells.length, true); await sleep(450); }
            for (var j = it.h.length - 1; j >= 0 && on(); j--) { paintSocial(x, it, j, null, 0, true); await sleep(22); }
            await sleep(250);
          }
        })();
      });
    });
  }

  // a plate box that wipes through faces, with a chip naming each one
  function cycler(lp, faces, hold) {
    var plate = lp.querySelector('.lp__plate'); plate.textContent = '';
    var box = el('div', 'cxp'); plate.appendChild(box);
    var chip = el('span', 'lp__chip'); lp.appendChild(chip);
    var st = new Stage(box);
    var put = function (i, anim) { st.show(faces[i], anim); if (anim && !reduce) setTimeout(function () { chip.textContent = faces[i].name; }, 600); else chip.textContent = faces[i].name; };
    put(0, false);
    window.addEventListener('resize', function () { faces.forEach(function (f) { if (f.fit && f.node.parentNode) f.fit(); }); });
    if (reduce) return;
    var n = 0;
    watch(lp, function (on) {
      return (async function () {
        while (on()) { await sleep(hold); if (!on()) break; n = (n + 1) % faces.length; put(n, true); }
      })();
    });
  }
  function logo(lp) {
    Promise.all(FINISHES.map(function (f) { return preload(f.bg); }).concat([preload(LOGO)])).then(function () {
      cycler(lp, FINISHES.map(function (f) { return logoFace(f); }), 2300);
    });
  }
  // plain plates (blackout covers, real carbon covers): just the finish, no print
  var BLACKOUT = [
    { name: 'Black', css: 'linear-gradient(160deg,#2a2b2f 0%,#0a0a0b 46%,#151518 100%)' },
    { name: 'White', css: 'linear-gradient(160deg,#ffffff 0%,#e9e9e6 55%,#d9d9d5 100%)' }
  ];
  var CARBON = [
    { name: 'Carbon Fiber Twill', bg: FILES + 'Jap_Plate_Carbon_Twill.png' },
    { name: 'Forged Carbon', bg: FORGED }
  ];
  function plainFace(fin) {
    var f = el('div', 'cxp__f cxp__lg');
    if (fin.bg) finish(f, fin.bg); else f.style.background = fin.css;
    // a child keeps the theme's div:empty rule from hiding the face; it also carries the gloss
    f.appendChild(el('i', 'cxp__sheen'));
    return { node: f, name: fin.name };
  }
  function plain(lp, list) {
    Promise.all(list.filter(function (f) { return f.bg; }).map(function (f) { return preload(f.bg); })).then(function () {
      cycler(lp, list.map(plainFace), 2400);
    });
  }
  // vanity plates (bolt-on): our logo on each finish with the mounting holes (no Japanese plate here; that has its own tile); mini is a 4:1 strip
  function vanityTile(lp) {
    var faces = FINISHES.map(function (f) { return logoFace(f, true); });
    Promise.all(FINISHES.map(function (f) { return preload(f.bg); }).concat([preload(LOGO)])).then(function () {
      cycler(lp, faces, 2600);
    });
  }
  function miniTile(lp) {
    Promise.all(FINISHES.map(function (f) { return preload(f.bg); }).concat([preload(LOGO)])).then(function () {
      cycler(lp, FINISHES.map(function (f) { return logoFace(f, 'mini'); }), 2600);
    });
  }
  function jdmHoles(lp) {
    var looks = [holed(JP_LOOKS[0]), holed(JP_LOOKS[2])];
    var fonts = document.fonts ? Promise.all(['65px cxp_jp', '55px cxp_jp_top', '112px cxp_jp_bot'].map(function (f) { return document.fonts.load(f, '足立ふ123ABC').catch(function () {}); })) : Promise.resolve();
    Promise.all([fonts, preload(FILES + looks[0].bg), preload(FILES + looks[1].bg)]).then(function () {
      cycler(lp, looks.map(jpFace), 2800);
    });
  }
  function jdm(lp) {
    var fonts = document.fonts ? Promise.all(['65px cxp_jp', '55px cxp_jp_top', '112px cxp_jp_bot'].map(function (f) { return document.fonts.load(f, '足立ふ123ABC').catch(function () {}); })) : Promise.resolve();
    var imgs = [];
    JP_LOOKS.forEach(function (l) { imgs.push(preload(FILES + l.bg), preload(FILES + l.bd)); });
    Promise.all([fonts].concat(imgs.slice(0, 2))).then(function () {
      cycler(lp, JP_LOOKS.map(jpFace), 2600);
    });
  }

  /* ------------------------------------------------------------------ plate frames */
  // a frame face: finish (black, white or a carbon photo), a plain plate in the window, the two top mounting holes, and what's printed on the bars
  var plateFont = null;
  function loadPlateFont(url) {
    if (!plateFont && url && window.FontFace) plateFont = new FontFace('LP Plate', 'url(' + url + ')').load().then(function (f) { document.fonts.add(f); }).catch(function () {});
    return plateFont || Promise.resolve();
  }
  // a frame face: the plate behind, the photo cutout of the frame on top (window and holes are see-through), then the print
  function frameFace(o) {
    var fin = o.fin || 'print', carbon = fin === 'forged' || fin === 'twill';
    var f = el('div', 'cxp__f cxp__fr ' + (carbon ? 'is-carbon' : 'is-' + (fin === 'white' ? 'white' : 'black')));
    f.appendChild(el('span', 'fr__pl'));
    var im = el('img', 'fr__img'); im.src = FR_IMG[fin]; im.alt = ''; f.appendChild(im);
    var top = el('span', 'fr__top'); if (o.logo) { var lg = el('img'); lg.src = LOGO; lg.alt = ''; top.appendChild(lg); } f.appendChild(top);
    var bot = el('span', 'fr__bot' + (o.soc ? ' is-soc' : '')); if (o.words) bot.textContent = o.words; f.appendChild(bot);
    return { node: f, name: o.name, bot: bot };
  }
  function frameLogo(lp) {
    Promise.all([preload(LOGO), preload(PLATE), preload(FR_IMG.print), preload(FR_IMG.white), loadPlateFont(lp.getAttribute('data-pf'))]).then(function () {
      cycler(lp, [
        frameFace({ color: 'black', logo: 1, words: 'covermyplate.com', name: 'Black frame' }),
        frameFace({ fin: 'white', logo: 1, words: 'Made for the meet', name: 'White frame' }),
        frameFace({ color: 'black', logo: 1, words: 'Your words here', name: 'Your logo, your words' })
      ], 2500);
    });
  }
  function frameCarbon(lp) {
    Promise.all([preload(FR_IMG.twill), preload(FR_IMG.forged), preload(LOGO), preload(PLATE), loadPlateFont(lp.getAttribute('data-pf'))]).then(function () {
      cycler(lp, [
        frameFace({ fin: 'twill', name: 'Carbon Fiber Twill' }),
        frameFace({ fin: 'forged', name: 'Forged Carbon' }),
        frameFace({ fin: 'twill', logo: 1, name: 'Custom: your logo' })
      ], 2500);
    });
  }
  // social frame: our handles type into the bottom bar, then "yourhandle"
  function frameSocial(lp) {
    var plate = lp.querySelector('.lp__plate'); plate.textContent = '';
    var box = el('div', 'cxp'); plate.appendChild(box);
    var chip = el('span', 'lp__chip'); lp.appendChild(chip);
    var face = frameFace({ color: 'black', soc: 1, name: '' });
    new Stage(box).show(face, false);
    var bot = face.bot, ic = el('img'), tx = el('span'), caret = el('i', 'fr__caret');
    ic.alt = ''; bot.appendChild(ic); bot.appendChild(tx); bot.appendChild(caret);
    var list = socialList(lp), names = { ig: 'Instagram', tt: 'TikTok' };
    var set = function (it, n) { if (ICONS[it.p]) ic.src = ICONS[it.p].src; tx.textContent = '@' + it.h.slice(0, n); };
    Promise.all([loadHand(lp.getAttribute('data-hand')), icons(lp), loadPlateFont(lp.getAttribute('data-pf'))]).then(function () {
      var last = list[list.length - 1];
      set(reduce ? last : list[0], reduce ? last.h.length : 0); chip.textContent = reduce ? 'Your handle' : names[list[0].p];
      if (reduce) { caret.remove(); return; }
      var n = 0;
      watch(lp, function (on) {
        return (async function () {
          while (on()) {
            var k = n++ % list.length, it = list[k];
            chip.textContent = it.h === 'yourhandle' ? 'Your handle' : names[it.p];
            for (var i = 1; i <= it.h.length && on(); i++) { set(it, i); await sleep(75 + Math.random() * 45); }
            await sleep(1700);
            for (var j = it.h.length - 1; j >= 0 && on(); j--) { set(it, j); await sleep(24); }
            await sleep(250);
          }
        })();
      });
    });
  }

  /* ------------------------------------------------------------------ the plate on the Supra */
  // data-cxp-morph on the photo's wrapper: data-cxp-plate="x1,y1,x2,y2" are the plate's corners in the photo's own pixels.
  function heroMorph(wrap) {
    var img = wrap.querySelector('img'); if (!img) return;
    // "x1,y1,x2,y2" is a plate cover photo; "vanity:x1,y1,x2,y2" is a bolted-on vanity plate photo
    // an optional "@3000" before the colon says the corners were measured on a 3000px-wide original, so a resized photo still lines up
    var spec = wrap.getAttribute('data-cxp-plate') || '', vanity = /^vanity\b/i.test(spec);
    var bw0 = +((spec.match(/^[a-z]*@(\d+):/i) || [])[1] || 0);
    var r0 = spec.replace(/^[a-z]*(@\d+)?:/i, '').split(',').map(Number); if (r0.length !== 4 || r0.some(isNaN)) return;
    var r = r0.slice();
    var layer = el('div', 'cxp-layer'); layer.setAttribute('aria-hidden', 'true');
    var zi = getComputedStyle(img).zIndex; if (zi && zi !== 'auto') layer.style.zIndex = zi;
    img.parentNode.insertBefore(layer, img.nextSibling);
    var box = el('div', 'cxp-hero'); layer.appendChild(box);
    var inner = el('div', 'cxp'); box.appendChild(inner);
    var place = function () {
      var nw = img.naturalWidth, nh = img.naturalHeight; if (!nw) return;
      var k = bw0 ? nw / bw0 : 1; r = r0.map(function (v) { return v * k; });
      var bw = img.clientWidth, bh = img.clientHeight, s = Math.max(bw / nw, bh / nh);
      var pos = getComputedStyle(img).objectPosition.split(' ');
      var pc = function (v, free) { return /%$/.test(v) ? parseFloat(v) / 100 * free : parseFloat(v) || 0; };
      var ox = pc(pos[0], bw - nw * s), oy = pc(pos[1] || '50%', bh - nh * s);
      // the image box may not start at the layer's corner (it fills it in both sections, but measure to be safe)
      var ib = img.getBoundingClientRect(), lb = layer.getBoundingClientRect();
      var x = ib.left - lb.left + ox + r[0] * s - 1, y = ib.top - lb.top + oy + r[1] * s - 1;
      box.style.left = x + 'px'; box.style.top = y + 'px';
      box.style.width = ((r[2] - r[0]) * s + 2) + 'px'; box.style.height = ((r[3] - r[1]) * s + 2) + 'px';
      faces.forEach(function (f) { if (f.fit && f.node.parentNode) f.fit(); });
    };
    var faces = [];
    var src = wrap.closest('[data-ig]') || wrap;
    var st = new Stage(inner);
    Promise.all([img.complete ? 1 : new Promise(function (ok) { img.addEventListener('load', ok, { once: true }); }),
      loadHand(src.getAttribute('data-hand')), icons(src), whenQR(),
      document.fonts ? Promise.all(['65px cxp_jp', '55px cxp_jp_top', '112px cxp_jp_bot'].map(function (f) { return document.fonts.load(f, '足立ふ123ABC').catch(function () {}); })) : 1,
      preload(FORGED), preload(LOGO), preload(FILES + JP_LOOKS[2].bg), preload(FILES + JP_LOOKS[2].bd),
      vanity ? preload(FILES + JP_HOLES['Jap_Plate_White.png']) : 1
    ]).then(function () {
      // starts as our social cover (it matches the cover in the photo), then morphs through the other plates
      faces = vanity
        // starts as a forged carbon plate with our logo (it matches the plate in the photo), then other vanity looks
        ? [logoFace(FINISHES[0], true), jpFace(holed(JP_LOOKS[0])), logoFace(FINISHES[2], true), jpFace(holed(JP_LOOKS[2])), logoFace(FINISHES[3], true)]
        : [socialFace(socialList(src)[0]), logoFace(FINISHES[0]), jpFace(JP_LOOKS[2]), socialFace(socialList(src)[1]), logoFace(FINISHES[3]), jpFace(JP_LOOKS[0])];
      st.show(faces[0], false); place();
      if (window.ResizeObserver) new ResizeObserver(place).observe(img); else window.addEventListener('resize', place);
      if (reduce) return;
      var n = 0;
      watch(wrap, function (on) {
        return (async function () {
          while (on()) { await sleep(2800); if (!on()) break; n = (n + 1) % faces.length; st.show(faces[n], true); }
        })();
      });
    });
  }

  function boot() {
    var lps = document.querySelectorAll('.lp[data-live]'), heroes = document.querySelectorAll('[data-cxp-morph]');
    if (!lps.length && !heroes.length) return;
    if (!document.getElementById('lp-css')) { var s = document.createElement('style'); s.id = 'lp-css'; s.textContent = CSS; document.head.appendChild(s); }
    lps.forEach(function (lp) {
      if (lp._lp) return; lp._lp = 1;
      var k = lp.getAttribute('data-live');
      lp.classList.add('lp--' + k);
      if (k === 'social') social(lp); else if (k === 'logo') logo(lp); else if (k === 'jdm') jdm(lp); else if (k === 'blackout') plain(lp, BLACKOUT); else if (k === 'carbon') plain(lp, CARBON); else if (k === 'vanity') vanityTile(lp); else if (k === 'mini') miniTile(lp); else if (k === 'jdmv') jdmHoles(lp); else if (k === 'flogo') frameLogo(lp); else if (k === 'fsocial') frameSocial(lp); else if (k === 'fcarbon') frameCarbon(lp);
    });
    heroes.forEach(function (h) { if (h._cxp) return; h._cxp = 1; heroMorph(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
